import gsap from 'gsap';
import formatPrice from '../../helpers/formatPrice';

const counter = (to, onUpdateCallback, onCompleteCallback) => {
  const obj = { count: 0 };

  return gsap.to(obj, {
    count: to,
    delay: 0.25,
    duration: 1.5,
    roundProps: 'count',
    onUpdate() {
      onUpdateCallback(obj.count);
    },
    onComplete() {
      onCompleteCallback();
    },
  });
};

const parseCount = (count) => {
  if (!count) return null;

  const parsedCount = count.replace(/[^0-9]/g, '');

  return parseInt(parsedCount, 10);
};

const animateBlock = (block) => {
  const count = parseCount(block.dataset.count);
  const { title } = block.dataset;

  if (count && typeof count === 'number') {
    counter(count, (number) => {
      block.textContent = formatPrice(number, 0, '');
    }, () => {
      block.textContent = title;
    });

    return;
  }

  counter(title.length, (number) => {
    block.textContent = title.substr(0, number);
  }, () => {
    block.textContent = title;
  });
};

export default (element, isIntersecting) => {
  if (!isIntersecting || element.classList.contains('is-counted')) {
    return;
  }

  element.classList.add('is-counted');

  const blockLeft = element.querySelector('.js-data-block-left');
  const blockMiddle = element.querySelector('.js-data-block-middle');
  const blockRight = element.querySelector('.js-data-block-right');

  if (blockLeft) {
    animateBlock(blockLeft);
  }

  if (blockMiddle) {
    animateBlock(blockMiddle);
  }

  if (blockRight) {
    animateBlock(blockRight);
  }
};
